import { lazy, Suspense, useState } from 'react';

import type { PersonOpenBankAccountProps } from './person-bank-account-sheet.types';

// Porta do "Abrir conta" (OpenBankAccount.tsx) para a operação de crédito: leve de propósito; o diálogo e o fio só
// carregam na primeira abertura (import dinâmico).

export type { PersonOpenBankAccountProps } from './person-bank-account-sheet.types';

const Content = lazy(() => import('./screens/person-open-bank-account').then((module) => ({ default: module.PersonOpenBankAccountContent })));

/** "Abrir conta": reserva o número da conta transitória da pessoa física, com prévia e o toast do legado. */
export function PersonOpenBankAccount(props: PersonOpenBankAccountProps) {
  const [used, setUsed] = useState(props.open);
  if (props.open && !used) setUsed(true);
  if (!used) return null;
  return (
    <Suspense fallback={null}>
      <Content {...props} />
    </Suspense>
  );
}
